/**
 * This is an automatically generated file.
 * DO NOT CHANGE IT !
 */
export const versionInfo = {
  version: '1.4.1'
};